import { render, staticRenderFns } from "./AddWarrantyConfig.vue?vue&type=template&id=797feedc&scoped=true&"
import script from "./AddWarrantyConfig.vue?vue&type=script&lang=js&"
export * from "./AddWarrantyConfig.vue?vue&type=script&lang=js&"
import style0 from "./AddWarrantyConfig.vue?vue&type=style&index=0&id=797feedc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797feedc",
  null
  
)

export default component.exports